import { NumberTransform } from '@ember-data/serializer/transform'
export default NumberTransform
